import type { ReactNode } from "react";
import { Button } from "@repo/ui";

type Props = {
  id: string;
  icon: ReactNode;
  label: string;
  onClick: () => void;
};

export const ViewNavigationButton = ({ id, icon, label, onClick }: Props) => (
  <div className="flex items-center gap-2">
    <Button id={id} size="icon_md" variant="outline" icon={icon} onClick={onClick} />
    <label className="cursor-pointer" htmlFor={id}>
      {label}
    </label>
  </div>
);
